function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0rt{fill:#F0F0F0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0rt",
  d: "M16.46,32.92C7.38,32.92,0,25.54,0,16.46S7.38,0,16.46,0s16.46,7.38,16.46,16.46S25.54,32.92,16.46,32.92z  M16.46,2.11c-7.91,0-14.35,6.44-14.35,14.35s6.44,14.35,14.35,14.35s14.35-6.44,14.35-14.35S24.37,2.11,16.46,2.11z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0rt",
  d: "M16.04,3.38c0.18,1.06,0.32,2.11,0.43,3.17c-0.02,1.06-0.01,2.11-0.01,3.17v6.33v0.17l-0.12,0.12l-4.01,4.01 c-0.68,0.66-1.32,1.35-2.02,1.99c-0.76,0.57-1.5,1.17-2.29,1.72c0.55-0.78,1.15-1.52,1.72-2.29c0.64-0.7,1.33-1.35,1.99-2.02 l4.01-4.01l-0.12,0.3V9.71c0-1.06,0.01-2.11-0.01-3.17C15.72,5.49,15.86,4.43,16.04,3.38z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0rt",
  cx: 16.04,
  cy: 16.04,
  r: 1.69
}));

var SvgMenuRecent = function SvgMenuRecent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.92 32.92",
    style: {
      enableBackground: "new 0 0 32.92 32.92"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuRecent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu_Recent.7512edeb.svg";
export { ForwardRef as ReactComponent };